var exports = module.exports = {}
const objects = require('./object_names.json')

var language = window.navigator.userLanguage || window.navigator.language
if (language.includes('-')) language = language.substring(0, language.indexOf('-'))

const listLanguages = ['en', 'es', 'de', 'fr', 'ru', 'pl', 'zh', 'jp', 'pt', 'it', 'nl']
if (!listLanguages.includes(language)) language = 'en'

exports.language = function () {
  return language
}

exports.updateLanguage = function (lang) {
  language = lang
}

exports.objects = objects
